import insuranceLogos from './insurance-logos.json';
import BrokerageLogoGroup from './BrokerageLogoGroup';
import styles from './RegisteredBrokeragesLogos.module.scss';
import clsx from 'clsx';

interface Props {
  iconColor?: 'default' | 'gray';
}

export default function InsuranceLogos({ iconColor = 'default' }: Props) {
  return (
    <BrokerageLogoGroup
      logos={insuranceLogos.data}
      classes={{ logoContainer: styles.brokerageLogoContainer }}
      className={clsx(styles.insuranceContainer, {
        [styles.gray]: iconColor === 'gray',
      })}
    />
  );
}
